export default __webpack_public_path__ + "static/pic6-cc3c39b4ad739b62d147d6fc0f572980.jpeg";